/**
 * 📊 Panel veri kapısı.
 *
 * Bu üç sorgu `utils/abacus/dashboard.ts` içinde duruyordu — yani bir HESAP
 * modülünün içinde. Ölçü aletinin gövdesine su borusu döşenmiş gibiydi:
 * hesabı sınamak için veritabanı gerekiyordu.
 *
 * Sorgular buraya geldi, hesap orada kaldı. `dashboard.ts` artık kendisine
 * verilen veriden üretiyor.
 *
 * Yanıtlar HAM Supabase biçiminde (`{ data, error }`) dönüyor; panel
 * toplayıcısı her kaynağın ayrı ayrı çökmesine farklı tepki verdiği için
 * hatayı burada yutmak yanlış olurdu. Tepkileri
 * `utils/abacus/dashboard.characterization.test.ts` çiviliyor.
 */

import { supabase } from '@/lib/supabase'

/** Kullanıcının profili + kayıtlı IBAN'ları. Panelin ZORUNLU kaynağı. */
export function fetchProfile(userId: string, signal?: AbortSignal) {
  let q = supabase.from('users').select('*, ibans:user_ibans(*)').eq('id', userId)
  if (signal) q = q.abortSignal(signal)
  return q.single()
}

/**
 * Kullanıcının ETKİN üyeliklerinden gidilerek grupları ve grupların tüm
 * üyeleri. Gruptan ayrılmış kullanıcı grubu görmesin diye `status` süzgeci
 * şart.
 */
export function fetchActiveGroupMemberships(userId: string, signal?: AbortSignal) {
  let q = supabase
    .from('group_members')
    .select(
      `
        group:groups (
            *,
            group_members (
                user_id, turn_index, status, display_name,
                users (id, full_name, avatar_url, google_avatar_url, apple_avatar_url)
            )
        )
    `
    )
    .eq('user_id', userId)
    .eq('status', 'active')
  if (signal) q = q.abortSignal(signal)
  return q
}

/**
 * Kullanıcının KURDUĞU günler. Organizatör listede kendine sıra almamış olabilir
 * (B-26); bu günler üyelik sorgusuna düşmediği için ayrıca çekilir.
 */
export function fetchOwnedGroups(userId: string, signal?: AbortSignal) {
  let q = supabase
    .from('groups')
    .select(
      `
        *,
        group_members (
            user_id, turn_index, status, display_name,
            users (id, full_name, avatar_url, google_avatar_url, apple_avatar_url)
        )
    `
    )
    .eq('created_by', userId)
    .in('status', ['waiting', 'active', 'completed'])
  if (signal) q = q.abortSignal(signal)
  return q
}

/**
 * Kullanıcının gönderdiği VEYA aldığı, hâlâ geçerli sayılan işlemler.
 * Reddedilmiş ve atlanmış olanlar gelmez — ajanda hesabı "bu döngüde ödedi
 * mi" sorusunu bunun üzerinden yanıtlıyor.
 */
export function fetchUserActiveTransactions(userId: string, signal?: AbortSignal) {
  let q = supabase
    .from('transactions')
    .select('id, group_id, sender_id, receiver_id, cycle_number, status')
    .or(`sender_id.eq.${userId},receiver_id.eq.${userId}`)
    .in('status', ['pending', 'confirmed', 'auto_confirmed'])
  if (signal) q = q.abortSignal(signal)
  return q
}
